export const SET_COMMENTS = 'comments/SET_COMMENTS';
export const SET_POST_COMMENT_DATA = 'comments/SET_POST_COMMENT_DATA';
export const SET_MASSIVE_COMMENTS = 'comments/SET_MASSIVE_COMMENTS';
export const SET_TICKET_COMMENT_ID = 'comments/SET_TICKET_COMMENT_ID';

// * FETCH
export const FETCH_COMMENTS = 'comments/FETCH_COMMENTS';
export const FETCH_MASSIVE_COMMENTS = 'comments/FETCH_MASSIVE_COMMENTS';
export const FETCH_TICKET_COMMENTS_ID = 'comments/FETCH_TICKET_COMMENTS_ID';

// * POST
export const POST_COMMENTS = 'comments/POST_COMMENTS';
export const POST_MASSIVE_COMMENTS = 'comments/POST_MASSIVE_COMMENTS';

// * GET
export const GET_MASSIVE_COMMENTS = 'comments/GET_MASSIVE_COMMENTS';
export const GET_COMMENT_TICKET_ID = 'comments/GET_COMMENT_TICKET_ID';
